import { useQuery } from '@tanstack/react-query';
import { getRelatedRecordsCount } from 'services/api/requests/commercial';

interface RelatedRecordsCount {
	vendas: number;
	carteira_pedidos: number;
	oportunidades: number;
	orcamentos: number;
	planos_irrestritos: number;
	planos_restritos: number;
	planos_colaboracao_comercial: number;
	planos_colaboracao_marketing: number;
	planos_colaboracao_planejamento: number;
	total: number;
}

export const useGetRelatedRecordsCount = (
	hierarchyId: number | null,
	enabled: boolean = true
) => {
	return useQuery<RelatedRecordsCount>(
		['relatedRecordsCount', hierarchyId],
		() => getRelatedRecordsCount(hierarchyId!),
		{
			enabled: enabled && hierarchyId !== null,
			staleTime: 5 * 60 * 1000, // 5 minutos
			cacheTime: 10 * 60 * 1000, // 10 minutos
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
		}
	);
};
